import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux'
import SocialNetwork from './social-network/SocialNetwork'
import BrowseFriends from './browse-friends/BrowseFriends'
import FindFriends from './find-friends/FindFriends'
import MultiuserExplorer from "./multi-user-mindfiles/MultiuserExplorer";

const Social = ({loading, isCurrentMindfileOwner, hasFriends}) => (
  <div style={{position:'relative', height:'100%'}}>
    <div style={
      {
        padding: '1rem',
        backgroundColor: "rgba(0, 62, 88, 0.025)",
        height: '100%'
      }}>
      <Switch>
        <Route exact path="/social">
          {loading ? <BrowseFriends /> : <Redirect to={isCurrentMindfileOwner && !hasFriends ? "/social/find-friends" : "/social/browse-friends"}/>}
        </Route>
        { isCurrentMindfileOwner ? <Route path="/social/find-friends" component={FindFriends}/> : null }
        <Route path="/social/social-network" component={SocialNetwork}/>
        <Route path="/social/multi-user-mindfiles" component={MultiuserExplorer}/>
        <Route path="/social/browse-friends" component={BrowseFriends}/>
      </Switch>
    </div>
  </div>
)

const mapStateToProps = (state) => ({
  loading: state.mindfile.loading || state.friends.initialState === true,
  isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  hasFriends: state.friends.length > 0,
})

export default connect(mapStateToProps)(Social)
